export enum ParamOrdenamientoGlosas {
    FECHA_OPERACION,
    DNI_EMPLEADOR,
    NOMBRE_EMPLEADOR,
    UEN,
    CODIGO_SERVICIO,
    CODIGO_GLOSA,
    ESTADO_GLOSA,
    ESTADO_POLIZA
}

export enum TipoOrdenamiento {
    ASCENDENTE,
    DESCENDENTE
}

export interface OrdenamientoGlosas {
    paramOrdenamiento: ParamOrdenamientoGlosas,
    tipoOrdenamiento: TipoOrdenamiento
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/modelo/OrdenamientoGlosas.ts